module.exports = __webpack_public_path__ + "img/drone.5f5af1cd.png";